<div class="mobile-header">
  <a class="back-btn text-white" [routerLink]="['/games']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
  <h5 class="title">{{ 'polls.page.title' | translate }}</h5>
</div>
<fgb-mobile-banner></fgb-mobile-banner>

<router-outlet></router-outlet>
